import { createContext, useContext } from 'react';
export const BreakpointIndexContext = createContext(0);
export const useBreakpointIndex = () => useContext(BreakpointIndexContext);
//# sourceMappingURL=breakpoint-context.js.map